import { render, staticRenderFns } from "./Technicolor3StripProcess.vue?vue&type=template&id=444999bf&"
import script from "./Technicolor3StripProcess.vue?vue&type=script&lang=js&"
export * from "./Technicolor3StripProcess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports